import PayLaterIntro from 'features/payLater/screens/PayLaterIntro/PayLaterIntro';

export default function Page() {
  return <PayLaterIntro />;
}
